import React, {useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import JustValidate from 'just-validate';
import CsfMembreConsentModalDataLayer from "./CsfMembreConsentModalDataLayer";
import {
  startLoadingSpinner,
  stopLoadingSpinner
} from "../../../csf-ufc-pivotal/includes/utils";
import DrupalAccessTokenApi from "../../../../js/csf/DrupalAccessTokenApi";

export default function CsfMembreConsentModal({apiUrl, apiEnv, setShowConsentModal, setUseConsents}) {
  const [radio, setRadio] = useState(new Map());
  const [isError, setIsError] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [attestation, setAttestation] = useState(false);
  const [validator, setValidator] = useState(null);
  const [consents, setConsents] = useState([]);
  const [dataLayer, setDataLayer] = useState({});
  const dismissButton = useRef();

  /*
  * Call this method when an api error occurs.
  * */
  function apiErrorCallback(errorMessage) {
    setIsError(true);
    stopLoadingSpinner();
  }

  useEffect(() => {
    startLoadingSpinner();
    fetchAccessToken();
    $('#membreConsentModal').on('hidden.bs.modal', function() {
      const fieldsetError = document.querySelectorAll('.has-error');
      fieldsetError.forEach(label => {
        label.classList.remove('has-error');
      });
    });
  }, []);

  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest()
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          console.error('Error while fetching token');
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  useEffect(() => {
    if (accessToken) {
      const dataObj = new CsfMembreConsentModalDataLayer(apiUrl, apiEnv, accessToken, apiErrorCallback);
      dataObj.fetchConsentsInfo(setConsents);
      setDataLayer(dataObj);
    }
  }, [accessToken]);


  useEffect(() => {
    const validator = new JustValidate('#membreConsentModal');

    if(consents.length > 0){
      setUseConsents(true);
    }

    consents.map((item, index) => {
      if(setShowConsentModal && item.Csf_crc_consent === 0){
        setShowConsentModal(true);
      }

      setRadio((radio) =>
        new Map(radio).set(`radio-consent-${item.GSFT_Consentement_View_Id}`, {
          val: item.Csf_crc_consent,
          id: `consent-${item.GSFT_Consentement_View_Id}`
        })
      );

      validator.addRequiredGroup(
        `#consent-item-${index}`,
        window.Drupal.t('fournisseur.creation_form.validation.required')
      )
    })

    setValidator(validator);

    return () => validator.destroy();
  }, [consents]);


  function consentSubmit(e) {
    e.preventDefault();
    setIsError(false);
    if (validator) {
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          //api call - have fun Victor!
          for (var [key, value] of radio) {
            const radioGroupId = key.split("-consent-")[1];
            const radioValue = value.val;
            if (radioValue && radioGroupId) {
              const formData = {
                CSF_CRC_Consent: radioValue
              };
              dataLayer.submitConsents(radioGroupId, formData, dismissButton, setIsError);
            }
          }

          const fielsetError = document.querySelectorAll(".has-error");
          fielsetError.forEach(label => {
            label.classList.remove('has-error');
          });
        } else {
          const modalConsent = document.getElementById('membreConsentModal');
          console.error('Form validation failed!');
          modalConsent.classList.add('error-input');
            const errorLabels = document.querySelectorAll('.just-validate-error-label');
            errorLabels.forEach(label => {
              const parentFieldset = label.closest('fieldset');

              if (parentFieldset) {
                parentFieldset.classList.add('has-error');
              }
            });
        }
      });
    }
  }

  function handleChange(e) {
    if (validator) {
      validator.validate();
      e.target.closest('fieldset')?.classList.remove('has-error');
    }
    return setRadio((radio) =>
      new Map(radio).set(e.target.name, {
        val: e.target.value,
        id: e.target.id
      })
    );
  }

  return (
    <div className="modal fade modal-consent" id="membreConsentModal" tabIndex="-1" role="dialog"
         aria-labelledby="membreConsentModalTitle"
         aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <form className="modal-content" onSubmit={consentSubmit}>
          <div className="modal-header d-flex align-items-center">
            <h2 id="membreConsentModalTitle">{window.Drupal.t('member.consent.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal"
                    aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            {isError === true && (
              <div className="alert alert-danger mt-1" role="alert"
                   aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
            )}

            {consents.map((item, index) => (
              <fieldset key={`consent-item-${index}`} id={`consent-item-${index}`} className="company-wrapper">
                <div className="row">
                  <legend className="col-12 col-md-5">
                    {item.Company_id__Rn_Descriptor}
                  </legend>
                  <div className="col-12 col-md-3 d-flex align-items-center">
                    <div className="form-group">
                      <RadioInput value={"1"} id={`consent-${item.GSFT_Consentement_View_Id}`}
                             name={`radio-consent-${item.GSFT_Consentement_View_Id}`}
                             handleChange={handleChange} defaultChecked={item.Csf_crc_consent === 1}/>
                      <label
                        htmlFor={`consent-${item.GSFT_Consentement_View_Id}`}>{window.Drupal.t('member.consent.modal.consent')}</label>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 d-flex align-items-center">
                    <div className="form-group">
                      <RadioInput value={"2"} id={`noconsent-${item.GSFT_Consentement_View_Id}`}
                             name={`radio-consent-${item.GSFT_Consentement_View_Id}`}
                             handleChange={handleChange} defaultChecked={item.Csf_crc_consent === 2}/>
                      <label
                        htmlFor={`noconsent-${item.GSFT_Consentement_View_Id}`}>{window.Drupal.t('member.consent.modal.noconsent')}</label>
                    </div>
                  </div>
                </div>
              </fieldset>
            ))}

            <div className="membre-modal-box">
              <h3 className="mb-1">{window.Drupal.t('member.consent.modal.box.title')}</h3>
              <div dangerouslySetInnerHTML={{__html: window.Drupal.t('member.consent.modal.box.text')}}></div>
              <div className="form-group d-flex align-items-center">
                <input type="checkbox" id="consent-attestation" name="consent-attestation"
                       onChange={e => setAttestation(e.target.checked)}/>
                <label htmlFor="consent-attestation">{window.Drupal.t('member.consent.modal.box.label')}</label>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <div className="space-between-wrapper ">
              <button type="button" className='button btn-outlined btn-larger' data-dismiss="modal"
                      ref={dismissButton}>{window.Drupal.t('fournisseur.back.btn')}</button>
              <input
                className={`btn-submit btn-pale btn-larger ${attestation? "": "disabled"}`}
                {...(attestation ? {} : {tabIndex: -1})}
                type="submit"
                value={window.Drupal.t('fournisseur.gestion.submit.label')}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

function RadioInput({name, value, id, handleChange, defaultChecked}) {
  return (
      <input
        type="radio"
        name={name}
        value={value}
        id={id}
        onChange={handleChange}
        defaultChecked={defaultChecked}
      />
  );
}

RadioInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  handleChange: PropTypes.func,
  defaultChecked: PropTypes.bool
}


CsfMembreConsentModal.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  setShowConsentModal: PropTypes.func,
  setUseConsents: PropTypes.func
};
